import { createSlice } from '@reduxjs/toolkit';
import { addHolidayThunk, deleteHolidayThunk, getHolidaysDataThunk } from './myHolidaysActions';
import { formatHolidayData } from './myHolidaysHelper';

export interface HolidaysList {
  holidaysData: any[];
  loading: boolean;
  isDeleting: boolean;
}

const initialState: HolidaysList = {
  holidaysData: [],
  loading: false,
  isDeleting: false,
};

const HolidaysListSlice = createSlice({
  name: 'Holidays List',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHolidaysDataThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHolidaysDataThunk.fulfilled, (state, action) => {
        state.holidaysData = formatHolidayData(action.payload);
        state.loading = false;
      })
      .addCase(getHolidaysDataThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addHolidayThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(addHolidayThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addHolidayThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteHolidayThunk.pending, (state) => {
        state.isDeleting = true;
      })
      .addCase(deleteHolidayThunk.fulfilled, (state) => {
        state.isDeleting = false;
      })
      .addCase(deleteHolidayThunk.rejected, (state) => {
        state.isDeleting = false;
      });
  },
});

// export const { } = HolidaysListSlice.actions;
export default HolidaysListSlice.reducer;
